function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1095 389)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.09,57H3V22a5,5,0,0,1,5-5H23a5,5,0,0,1,5,5V34.09A25.17,25.17,0,0,0,11.09,57Z",
  transform: "translate(-1095 -389)",
  fill: "none",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 14,
  rx: 2,
  transform: "translate(-1088 -386)",
  fill: "none",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.08,41V53h-7V18.88H68.36a15.35,15.35,0,0,1,6.76,1.4,10.36,10.36,0,0,1,4.49,4,11.09,11.09,0,0,1,1.57,5.89,9.78,9.78,0,0,1-3.43,7.91Q74.32,41,68.24,41Zm0-5.7h6.28A6.18,6.18,0,0,0,72.61,34a4.78,4.78,0,0,0,1.47-3.75,5.64,5.64,0,0,0-1.48-4.06,5.5,5.5,0,0,0-4.08-1.59H62.08Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.81,34a19.25,19.25,0,0,0-2.43-.19q-3.85,0-5,2.61V53H85.56V27.64H92l.19,3a6.29,6.29,0,0,1,5.65-3.49,6.9,6.9,0,0,1,2.11.31Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.17,40.09a15.16,15.16,0,0,1,1.45-6.73,10.66,10.66,0,0,1,4.19-4.57,12.18,12.18,0,0,1,6.34-1.62,11.58,11.58,0,0,1,8.38,3.14,12.64,12.64,0,0,1,3.62,8.53v1.74a13.25,13.25,0,0,1-3.26,9.36,12.62,12.62,0,0,1-17.5,0q-3.27-3.51-3.27-9.56Zm6.78.48a9.49,9.49,0,0,0,1.35,5.52,4.88,4.88,0,0,0,7.74,0q1.38-1.89,1.38-6A9.4,9.4,0,0,0,117,34.58a4.49,4.49,0,0,0-3.89-1.95,4.44,4.44,0,0,0-3.85,1.94q-1.26,1.93-1.26,6Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.48,21.41v6.23h4.33v5h-4.33V45.27a3,3,0,0,0,.54,2,2.68,2.68,0,0,0,2.06.61,10.76,10.76,0,0,0,2-.16v5.13a13.8,13.8,0,0,1-4.1.61q-7.12,0-7.27-7.2V32.61H127v-5h3.7v-6.2Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.26,53.47a12.44,12.44,0,0,1-9.08-3.42,12.15,12.15,0,0,1-3.51-9.12v-.66a15.26,15.26,0,0,1,1.48-6.83,10.84,10.84,0,0,1,4.18-4.64,11.74,11.74,0,0,1,6.18-1.63,10.54,10.54,0,0,1,8.19,3.28q3,3.29,3,9.31v2.76H151.54a6.31,6.31,0,0,0,2,4A6,6,0,0,0,157.7,48a7.32,7.32,0,0,0,6.12-2.84l3.33,3.73A10.11,10.11,0,0,1,163,52.26,13.41,13.41,0,0,1,157.26,53.47Zm-.78-20.84A4.25,4.25,0,0,0,153.21,34a7.07,7.07,0,0,0-1.6,3.91H161v-.55a5,5,0,0,0-1.22-3.49A4.38,4.38,0,0,0,156.48,32.63Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.48,21.08a3.34,3.34,0,0,1,1-2.51,4.42,4.42,0,0,1,5.55,0,3.59,3.59,0,0,1,0,5,3.85,3.85,0,0,1-2.76,1,3.81,3.81,0,0,1-2.75-1,3.32,3.32,0,0,1-1.04-2.49ZM178.68,53h-6.8V27.64h6.8Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.49,27.64l.21,2.93a8.86,8.86,0,0,1,7.29-3.4q4,0,6,2.37c1.31,1.58,2,3.94,2,7.08V53h-6.78V36.78a4.42,4.42,0,0,0-.93-3.13,4.21,4.21,0,0,0-3.12-1,4.65,4.65,0,0,0-4.29,2.44V53H184.1V27.64Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.07,39.05h-13.5V53h-7V18.88h22.22v5.69H230.57v8.81h13.5Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.34,21.08a3.34,3.34,0,0,1,1-2.51,4.42,4.42,0,0,1,5.55,0,3.57,3.57,0,0,1,0,5,4.35,4.35,0,0,1-5.5,0A3.32,3.32,0,0,1,249.34,21.08ZM256.54,53h-6.8V27.64h6.8Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268.35,27.64l.21,2.93a8.85,8.85,0,0,1,7.29-3.4q4,0,6,2.37c1.31,1.58,2,3.94,2,7.08V53h-6.78V36.78a4.42,4.42,0,0,0-.93-3.13,4.21,4.21,0,0,0-3.12-1,4.65,4.65,0,0,0-4.29,2.44V53H262V27.64Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288,40.13q0-5.93,2.66-9.44a8.6,8.6,0,0,1,7.27-3.52A7.76,7.76,0,0,1,304,29.94V17h6.8V53h-6.12l-.33-2.7a8,8,0,0,1-6.51,3.17,8.63,8.63,0,0,1-7.19-3.53Q288,46.42,288,40.13Zm6.77.51A10,10,0,0,0,296,46.11a4.06,4.06,0,0,0,3.61,1.9A4.55,4.55,0,0,0,304,45.36v-10a4.45,4.45,0,0,0-4.38-2.65q-4.9-.03-4.9,7.93Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.72,53.47a12.44,12.44,0,0,1-9.08-3.42,12.15,12.15,0,0,1-3.51-9.12v-.66a15.26,15.26,0,0,1,1.48-6.83,10.84,10.84,0,0,1,4.18-4.64A11.74,11.74,0,0,1,327,27.17a10.54,10.54,0,0,1,8.19,3.28q3,3.29,3,9.31v2.76H322a6.31,6.31,0,0,0,2,4,6,6,0,0,0,4.18,1.5,7.32,7.32,0,0,0,6.12-2.84l3.33,3.73a10.11,10.11,0,0,1-4.13,3.36A13.41,13.41,0,0,1,327.72,53.47ZM327,32.63A4.22,4.22,0,0,0,323.68,34a7,7,0,0,0-1.61,3.91h9.42v-.55a5,5,0,0,0-1.22-3.49A4.37,4.37,0,0,0,327,32.63Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.24,34a19.251,19.251,0,0,0-2.44-.19q-3.84,0-5,2.61V53H342V27.64h6.4l.19,3a6.29,6.29,0,0,1,5.65-3.49,6.9,6.9,0,0,1,2.11.31Z",
  transform: "translate(-1095 -389)",
  stroke: "none"
}));

var SvgLogotypeProteinFinder = function SvgLogotypeProteinFinder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    stroke: "currentColor",
    width: 356.35,
    height: 60,
    viewBox: "0 0 356.35 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogotypeProteinFinder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logotype-protein-finder.e3b8ff2a.svg";
export { ForwardRef as ReactComponent };